export default {
  uploadFileDialog: {
    dropzoneText: 'Arrastra tu archivo',
    buttonClose: 'Cerrar',
    buttonUpload: 'Subir archivo',
    dropzoneOptions: {
      dictDefaultMessage: 'Arrastra archivos aquí para cargarlos',
      dictFallbackMessage: 'Tu navegador no tiene soporte para subir archivos arrastrando.',
      dictFallbackText: 'Por favor usa el formulario de reserva de abajo para subir tus archivos como antes.',
      dictFileTooBig: 'Tamaño de archivo es demasiado grande ({{filesize}}MiB). Tamaño de archivo máximo: {{maxFilesize}}MiB.',
      dictInvalidFileType: 'No se pueden subir archivos de este tipo.',
      dictResponseError: 'El servidor respondió con un código de estatus {{statusCode}}.',
      dictCancelUpload: 'Cancelar carga',
      dictCancelUploadConfirmation: '¿Estás seguro de cancelar esta carga?',
      dictRemoveFile: 'Quitar archivo',
      dictMaxFilesExceeded: 'No se pueden subir más archivos.'
    }
  },
  dateRangeInput: {
    dateRange: 'Intervalo de fechas',
    cancel: 'Cancelar',
    ok: 'Ok'
  },
  pagination: {
    footerText: 'Filas por mostrar:'
  }
}
